import { useForm } from "react-hook-form";
import useGlobalMutation from "../../../hooks/useGlobalMutation";
import { FormContainer, TextInput } from "../../shared";
import { RegexPattern, clearCache } from "../../../utils";

const Form = ({ formData, formType, query }) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        mode: "onChange",
        defaultValues: {
            ...formData,
        },
    });

    const { submitMutation, loading } = useGlobalMutation(query, (cache) => {
        clearCache(cache, "allIccAppConfigurations");
    });

    const handleSubmission = async (data) => {
        const { appName, aemAppEnvironmentPath } = data;

        const variables =
            formType === "update"
                ? {
                      id: formData.id,
                      iccAppConfiguration: {
                          appName,
                          aemAppEnvironmentPath,
                      },
                  }
                : {
                      iccAppConfiguration: {
                          appName,
                          aemAppEnvironmentPath,
                      },
                  };

        const dataPath =
            formType === "update"
                ? "updateIccAppConfigurationById.iccAppConfiguration"
                : "createIccAppConfiguration.iccAppConfiguration";

        const isResultNull = await submitMutation(
            variables,
            dataPath,
            `ICC App ${formType === "update" ? "Updated" : "Created"} Successfully`
        );
        isResultNull === null && formType !== "update" && reset();
    };

    return (
        <FormContainer
            submitAction={handleSubmit(handleSubmission)}
            loading={loading}
            submitButtonText={`${formType === "update" ? "Update" : "Create"} ICC App`}
            submitBtnSm={formType === "update"}
        >
            <div className="row">
                <div className="col-md-6">
                    <TextInput
                        id="appName"
                        labelText="App Name"
                        {...register("appName", {
                            pattern: RegexPattern.name,
                            required: true,
                        })}
                        isInvalid={!!errors.appName}
                        required
                    />
                </div>
                <div className="col-md-6">
                    <TextInput
                        id="aemAppEnvironmentPath"
                        labelText="AEM App Environment Path"
                        {...register("aemAppEnvironmentPath", {
                            pattern: RegexPattern.nameWithoutSpace,
                            required: true,
                        })}
                        isInvalid={!!errors.aemAppEnvironmentPath}
                        required
                    />
                </div>
            </div>
        </FormContainer>
    );
};

export default Form;
